import React, { useState } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PerformanceMetrics = () => {
  const [activeTab, setActiveTab] = useState('resolution');

  const resolutionData = [
    { name: 'İlk Çağrıda Çözülen', value: 87.3, count: 2486, color: '#10b981' },
    { name: 'İkinci Çağrıda Çözülen', value: 8.7, count: 248, color: '#f59e0b' },
    { name: 'Üçüncü+ Çağrıda Çözülen', value: 4.0, count: 113, color: '#ef4444' }
  ];

  const satisfactionData = [
    { name: 'Çok Memnun', value: 45.2, count: 1287, color: '#10b981' },
    { name: 'Memnun', value: 32.8, count: 934, color: '#84cc16' },
    { name: 'Orta', value: 15.6, count: 444, color: '#f59e0b' },
    { name: 'Memnun Değil', value: 4.8, count: 137, color: '#f97316' },
    { name: 'Hiç Memnun Değil', value: 1.6, count: 45, color: '#ef4444' }
  ];

  const agentPerformance = [
    { name: 'Ahmet Y.', calls: 156, avgTime: '4:32', satisfaction: 4.8, resolution: 92 },
    { name: 'Elif K.', calls: 142, avgTime: '3:45', satisfaction: 4.6, resolution: 89 },
    { name: 'Mehmet S.', calls: 138, avgTime: '5:12', satisfaction: 4.4, resolution: 85 },
    { name: 'Ayşe D.', calls: 134, avgTime: '4:18', satisfaction: 4.7, resolution: 91 },
    { name: 'Can T.', calls: 129, avgTime: '4:56', satisfaction: 4.3, resolution: 83 },
    { name: 'Zeynep A.', calls: 125, avgTime: '3:58', satisfaction: 4.5, resolution: 88 }
  ];

  const tabs = [
    { id: 'resolution', label: 'Çözüm Oranları', icon: 'CheckCircle' },
    { id: 'satisfaction', label: 'Memnuniyet', icon: 'Star' },
    { id: 'agents', label: 'Temsilci Performansı', icon: 'Users' }
  ];

  const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
    if (percent < 0.05) return null;
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text 
        x={x} 
        y={y} 
        fill="white" 
        textAnchor={x > cx ? 'start' : 'end'} 
        dominantBaseline="central"
        fontSize={12}
        fontWeight="600"
      >
        {`${(percent * 100)?.toFixed(1)}%`}
      </text>
    );
  };

  return (
    <div className="bg-white rounded-lg border border-slate-200 p-6 shadow-subtle">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-slate-900">Performans Metrikleri</h3>
          <p className="text-sm text-slate-600">Detaylı performans analizi ve karşılaştırma</p>
        </div>
        
        <Button
          variant="outline"
          size="sm"
          iconName="Download"
          iconPosition="left"
        >
          Rapor İndir
        </Button>
      </div>
      {/* Tab Navigation */}
      <div className="flex items-center space-x-1 bg-slate-100 rounded-lg p-1 mb-6">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => setActiveTab(tab?.id)}
            className={`flex items-center space-x-2 px-4 py-2 text-sm font-medium rounded-md transition-colors ${
              activeTab === tab?.id
                ? 'bg-white text-slate-900 shadow-sm'
                : 'text-slate-600 hover:text-slate-900'
            }`}
          >
            <Icon name={tab?.icon} size={16} />
            <span>{tab?.label}</span>
          </button>
        ))}
      </div>
      {/* Tab Content */}
      <div className="h-80">
        {activeTab === 'resolution' && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 h-full">
            <div className="flex flex-col">
              <h4 className="text-sm font-medium text-slate-900 mb-4">Çağrı Çözüm Dağılımı</h4>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={resolutionData}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={renderCustomLabel}
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="value"
                  >
                    {resolutionData?.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry?.color} />
                    ))}
                  </Pie>
                  <Tooltip 
                    formatter={(value, name) => [`%${value}`, name]}
                    contentStyle={{
                      backgroundColor: 'white',
                      border: '1px solid #e2e8f0',
                      borderRadius: '8px',
                      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                    }}
                  />
                </PieChart>
              </ResponsiveContainer>
            </div>
            
            <div className="space-y-3">
              <h4 className="text-sm font-medium text-slate-900">Detaylı İstatistikler</h4>
              {resolutionData?.map((item, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                  <div className="flex items-center space-x-3">
                    <div 
                      className="w-4 h-4 rounded-full"
                      style={{ backgroundColor: item?.color }}
                    ></div>
                    <span className="text-sm font-medium text-slate-900">{item?.name}</span>
                  </div>
                  <div className="text-right">
                    <div className="text-sm font-semibold text-slate-900">{item?.value}%</div>
                    <div className="text-xs text-slate-600">{item?.count} çağrı</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'satisfaction' && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 h-full">
            <div className="flex flex-col">
              <h4 className="text-sm font-medium text-slate-900 mb-4">Müşteri Memnuniyet Dağılımı</h4>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={satisfactionData}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={renderCustomLabel}
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="value"
                  >
                    {satisfactionData?.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry?.color} />
                    ))}
                  </Pie>
                  <Tooltip 
                    formatter={(value, name) => [`%${value}`, name]}
                    contentStyle={{
                      backgroundColor: 'white',
                      border: '1px solid #e2e8f0',
                      borderRadius: '8px',
                      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                    }}
                  />
                </PieChart>
              </ResponsiveContainer>
            </div>
            
            <div className="space-y-3">
              <h4 className="text-sm font-medium text-slate-900">Memnuniyet Seviyeleri</h4>
              {satisfactionData?.map((item, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                  <div className="flex items-center space-x-3">
                    <div 
                      className="w-4 h-4 rounded-full"
                      style={{ backgroundColor: item?.color }}
                    ></div>
                    <span className="text-sm font-medium text-slate-900">{item?.name}</span>
                  </div>
                  <div className="text-right">
                    <div className="text-sm font-semibold text-slate-900">{item?.value}%</div>
                    <div className="text-xs text-slate-600">{item?.count} değerlendirme</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'agents' && (
          <div className="h-full">
            <h4 className="text-sm font-medium text-slate-900 mb-4">Temsilci Performans Karşılaştırması</h4>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-slate-200">
                    <th className="text-left py-3 px-4 text-sm font-medium text-slate-600">Temsilci</th>
                    <th className="text-center py-3 px-4 text-sm font-medium text-slate-600">Çağrı Sayısı</th>
                    <th className="text-center py-3 px-4 text-sm font-medium text-slate-600">Ort. Süre</th>
                    <th className="text-center py-3 px-4 text-sm font-medium text-slate-600">Memnuniyet</th>
                    <th className="text-center py-3 px-4 text-sm font-medium text-slate-600">Çözüm %</th>
                  </tr>
                </thead>
                <tbody>
                  {agentPerformance?.map((agent, index) => (
                    <tr key={index} className="border-b border-slate-100 hover:bg-slate-50">
                      <td className="py-3 px-4">
                        <div className="flex items-center space-x-3">
                          <div className="w-8 h-8 bg-slate-200 rounded-full flex items-center justify-center">
                            <Icon name="User" size={16} color="var(--color-text-secondary)" />
                          </div>
                          <span className="text-sm font-medium text-slate-900">{agent?.name}</span>
                        </div>
                      </td>
                      <td className="text-center py-3 px-4 text-sm text-slate-900">{agent?.calls}</td>
                      <td className="text-center py-3 px-4 text-sm text-slate-900">{agent?.avgTime}</td>
                      <td className="text-center py-3 px-4">
                        <div className="flex items-center justify-center space-x-1">
                          <Icon name="Star" size={14} color="#f59e0b" />
                          <span className="text-sm text-slate-900">{agent?.satisfaction}</span>
                        </div>
                      </td>
                      <td className="text-center py-3 px-4">
                        <span className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded-full ${
                          agent?.resolution >= 90 ? 'bg-green-100 text-green-800' :
                          agent?.resolution >= 85 ? 'bg-yellow-100 text-yellow-800': 'bg-red-100 text-red-800'
                        }`}>
                          {agent?.resolution}%
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PerformanceMetrics;